import IndexLayout from '../components/common/layouts/IndexLayout';
import AuthLayout from '../components/common/layouts/AuthLayout';
import LandingLayout from '../components/common/layouts/LandingLayout';
//landing page:
import MainPage from '../components/landing/MainPage';
import HowItWorks from '../components/landing/HowItWorks';
import Pricing from '../components/landing/Pricing';
import HortenTorp from '../components/landing/HortenTorp';
import Complaint from '../components/landing/Complaint';
import Faq from '../components/landing/Faq';
import Contact from '../components/landing/Contact';
import TermsAndConditions from '../components/landing/TermsAndConditions';
import PrivacyPolicy from '../components/landing/PrivacyPolicy';
import Sitemap from '../components/home/Sitemap';
import Help from '../components/landing/Help';
//booking:
import HomepageContent from '../components/home/HomepageContent';
import Booking from '../components/booking/Booking';
import KidsSafety from '../components/booking/KidsSafety/KidsSafety';
import Flight from '../components/booking/Flights/Flights';
import MapSearch from '../components/booking/Map/Map';
import UserData from '../components/booking/UserData/UserData';
import UserConfirmPhone from '../components/booking/UserData/UserConfirmPhone';
import Summary from '../components/booking/Summary/Summary';
import Confirmed from '../components/booking/Summary/Confirmed';
//login&register:
import RegistrationForm from '../components/auth/RegistrationForm';
import RegistrationFormStep1 from '../components/auth/RegistrationFormStep1';
import RegistrationFormStep2 from '../components/auth/RegistrationFormStep2';
import RegistrationFormStep3 from '../components/auth/RegistrationFormStep3';
import LoginPage from '../components/auth/LoginPage';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';
//dashboard:
import Dashboard from '../components/dashboard/Dashboard';
import DashboardEdit from '../components/dashboard/DashboardEdit';
import SupplementSummary from '../components/dashboard/SupplementSummary';
import MyTrips from '../components/account/MyTrips';
//account:
import Account from '../components/account/Account';
import Profile from '../components/account/Profile';
import MyCards from '../components/account/MyCards/MyCards';
import Places from '../components/account/Places/Places';
import MapHolder from '../components/account/Places/MapHolder';
import Invoices from '../components/account/Invoices';
import Settings from '../components/account/Settings';
import PricesContent from '../PricesContent';
import NotFound from '../NotFound';

import * as LAYOUT from './layoutTypes';
import TransHelper from 'components/common/translations/TransHelper';

const getRoutesList = (locale) => {

    const trans = (key) => {
       return TransHelper.translate(locale, key)
    }

    return [
        {
            component: Booking,
            path: trans('routes.url.booking'),
            sequence: 1,
            pageClasses: 'layout-booking',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        // {
        //     component: PricesContent,
        //     path: 'routes.url.prices'
        // },
        {
            component: KidsSafety,
            path: trans('routes.url.kidsSafety'),
            sequence: 2,
            pageClasses: 'layout-booking',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: Flight,
            path: trans('routes.url.flights'),
            sequence: 3,
            pageClasses: 'layout-booking',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: MapSearch,
            path: trans('routes.url.map'),
            sequence: 4,
            pageClasses: 'layout-booking layout-booking--map',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: UserData,
            path: trans('routes.url.userData'),
            sequence: 5,
            pageClasses: 'layout-booking',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: UserConfirmPhone,
            path: trans('routes.url.confirmPhone'),
            sequence: 6,
            pageClasses: 'layout-booking',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: Summary,
            path: trans('routes.url.summary'),
            sequence: 7,
            pageClasses: 'layout-booking',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: Confirmed,
            path: trans('routes.url.confirmed'),
            sequence: 8,
            pageClasses: 'layout-booking layout-booking--confirmed',
            layoutType: LAYOUT.BOOKING,
            fetchPageData: true,
        },
        {
            component: RegistrationForm,
            path: trans('routes.url.signup'),
            layout: AuthLayout,
            layoutType: LAYOUT.AUTH,
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: RegistrationFormStep1,
            path: trans('routes.url.registrationStep1'),
            layout: AuthLayout,
            layoutType: LAYOUT.AUTH,
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: RegistrationFormStep2,
            path: trans('routes.url.registrationStep2'),
            layout: AuthLayout,
            layoutType: LAYOUT.AUTH,
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: RegistrationFormStep3,
            path: trans('routes.url.registrationStep3'),
            layout: AuthLayout,
            layoutType: LAYOUT.AUTH,
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: LoginPage,
            path: trans('routes.url.login'),
            layout: AuthLayout,
            layoutType: LAYOUT.AUTH,
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: ResetPasswordForm,
            path: trans('routes.url.resetPassword'),
            layout: AuthLayout,
            layoutType: LAYOUT.AUTH,
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: Dashboard,
            path: trans('routes.url.dashboard'),
            sequence: 1,
            pageClasses: 'dashboard',
            layoutType: LAYOUT.DASHBOARD,
            fetchPageData: true,
        },
        {
            component: DashboardEdit,
            path: trans('routes.url.dashboardEdit'),
            sequence: 1,
            pageClasses: 'dashboard',
            layoutType: LAYOUT.DASHBOARD,
            fetchPageData: true,
        },
        {
            component: SupplementSummary,
            path: trans('routes.url.dashboardReservationPayment'),
            sequence: 2,
            pageClasses: 'dashboard',
            layoutType: LAYOUT.DASHBOARD,
            fetchPageData: true,
        },
        // {
        //     component: DashboardNoResults,
        //     path: '/:locale/dashboard/no-results',
        //     sequence: 2,
        //     pageClasses: 'dashboard',
        //     layoutType: LAYOUT.DASHBOARD
        // },
        // {
        //     component: DashboardNotification,
        //     path: '/:locale/dashboard/notification"',
        //     sequence: 2,
        //     pageClasses: 'dashboard',
        //     layoutType: LAYOUT.DASHBOARD
        // },
        {
            component: Account,
            path: trans('routes.url.account'),
            sequence: 1,
            pageClasses: 'account',
            layoutType: LAYOUT.ACCOUNT,
            fetchPageData: true,
        },
        {
            component: Profile,
            path: trans('routes.url.accountProfile'),
            layoutType: LAYOUT.ACCOUNT,
            pageClasses: 'account',
            sequence: 2,
            fetchPageData: true,
        },
        {
            component: MyCards,
            path: trans('routes.url.accountCards'),
            layoutType: LAYOUT.ACCOUNT,
            pageClasses: 'account',
            sequence: 2,
            fetchPageData: true,
        },
        {
            component: Places,
            path: trans('routes.url.accountPlaces'),
            layoutType: LAYOUT.ACCOUNT,
            pageClasses: 'account',
            sequence: 2,
            fetchPageData: true,
        },
        {
            component: MapHolder,
            path: trans('routes.url.accountPlacesMap'),
            layoutType: LAYOUT.ACCOUNT,
            pageClasses: 'account',
            sequence: 2,
            fetchPageData: true,
        },
        {
            component: Invoices,
            path: trans('routes.url.accountInvoices'),
            layoutType: LAYOUT.ACCOUNT,
            pageClasses: 'account',
            sequence: 2,
        },
        {
            component: Settings,
            path: trans('routes.url.accountSettings'),
            layoutType: LAYOUT.ACCOUNT,
            pageClasses: 'account',
            sequence: 2,
            fetchPageData: true,
        },
        {
            component: MyTrips,
            path: '/:locale/account/my-trips',
            sequence: 2,
            pageClasses: 'account',
            layoutType: LAYOUT.ACCOUNT,
            fetchPageData: true,
        },
        {
            component: MainPage,
            path: '/',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            fetchPageData: true,
        },
        {
            component: MainPage,
            path: trans('routes.url.home'),
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            fetchPageData: true,
        },
        {
            component: HowItWorks,
            path: trans('routes.url.howItWorks'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: Pricing,
            path: trans('routes.url.prices'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: HortenTorp,
            path: trans('routes.url.hortenTorp'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: Complaint,
            path: trans('routes.url.complaint'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: Faq,
            path: trans('routes.url.faq'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: Contact,
            path: trans('routes.url.contact'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: TermsAndConditions,
            path: trans('routes.url.termsAndConditions'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        {
            component: PrivacyPolicy,
            path: trans('routes.url.privacyPolicy'),
            pageClasses: 'layout-lp',
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout,
            sequence: 1,
            fetchPageData: true,
        },
        // {
        //     component: Sitemap,
        //     path: '/:locale/sitemap',
        //     layoutType: LAYOUT.LANDING,
        //     layout: LandingLayout,
        //     sequence: 1,
        // },
        {
            component: Help,
            path: trans('routes.url.help'),
            layoutType: LAYOUT.HELP,
            pageClasses: 'help',
            sequence: 0,
            fetchPageData: true,
        },
        {
            component: NotFound,
            layoutType: LAYOUT.LANDING,
            layout: LandingLayout
        }
    ];
}

export default getRoutesList;
